import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { config } from '@/config';
import { prepareHeaders } from '@/configuration/tokenHandling/prepareHeaders';

// ── Arg types ──

interface TriggerAllMessagesArgs {
    vin: string;
}

interface TriggerConfigMessageArgs {
    vin: string;
    messageIndex: number;
}

interface TriggerArbitraryMessageArgs {
    vin: string;
    cid: number;
    version: number;
    jsonMessage: unknown;
}

// ── API matching TriggerDfpMessageController ──

export const triggerDfpMessageApi = createApi({
    reducerPath: 'triggerDfpMessageApi',
    baseQuery: fetchBaseQuery({ baseUrl: config.backend.BACKEND_URI, prepareHeaders }),
    endpoints: (build) => ({
        triggerAllMessages: build.mutation<unknown, TriggerAllMessagesArgs>({
            query: ({ vin }) => ({
                url: '/dfp/trigger-all-messages',
                method: 'POST',
                body: { vin },
            }),
        }),

        triggerConfigMessage: build.mutation<string, TriggerConfigMessageArgs>({
            query: ({ vin, messageIndex }) => ({
                url: '/dfp/trigger-config-message',
                method: 'POST',
                body: { vin, message_index: messageIndex },
            }),
        }),

        triggerArbitraryMessage: build.mutation<void, TriggerArbitraryMessageArgs>({
            query: ({ vin, cid, version, jsonMessage }) => ({
                url: '/dfp/trigger-arbitrary-message',
                method: 'POST',
                body: { vin, cid, version, json_message: jsonMessage },
            }),
        }),
    }),
});

export const { useTriggerAllMessagesMutation, useTriggerConfigMessageMutation, useTriggerArbitraryMessageMutation } =
    triggerDfpMessageApi;
